import { createApp } from 'vue'
import myErrorDetailPopup, { usePopupEffect } from '@/components/MyErrorDetailPopup.vue'
import { Dialog } from 'vant';
import { createI18n } from 'vue-i18n';
import messages from '@/locales/i18n-messages';
import { getCurrentLanguage } from '@/effects/switchLanguageEffect'

const i18n = createI18n({
    locale: getCurrentLanguage(), // 默认语言
    messages,
});
const { msg, msgdata } = usePopupEffect()
//步骤
// 1.有个loading 的vue
// 2.挂载到父节点上  上树
// 3.挂载到全局的vue上
// 4.可以引用显示隐藏 即可处理。
// 既然是vue想要的效果的话,那就走这一套就行了。

// 走vue识别的那一套 的话 就需要 让vue识别 那就是createApp。然后挂载到节点上去。
const $loading = createApp(myErrorDetailPopup, { msg, msgdata }).use(Dialog).use(i18n).mount(document.createElement('div'))
document.body.appendChild($loading.$el)

const loaderror = {
    show({ traceId, code, message, detail }) { // 控制显示loading的方法
        msg.show = true
        msgdata.traceId = traceId
        msgdata.code = code
        msgdata.message = message
        msgdata.detail = detail
        // setTimeout(() => {
        //     this.hide()
        // }, 10000);
    },
    hide() { // 控制loading隐藏的方法
        msg.show = false
    }
}
export { loaderror }

